export class EntTypeTransportFilter {
	page: number = 1
	size: number = 30
	name: string | null = null
	categoryIds?: string | null = null
	categoryId?: string | null = null
}
